<script lang="ts" setup>
import type { RouteLocationNormalized } from 'vue-router'
import type { Team } from '~/types'

definePageMeta({
  layout: false,
  validate: (route: RouteLocationNormalized) => routeValidate(route),
})

const { params } = useRoute()

const slug = computed<string>(() => params?.slug.toString())
const paramsSearch: Team.SearchRequest = {
  include: [
    'contentBlocks',
    'logo',
    'menus',
    'metaImage',
    'nextEventBanners.image',
    'scheduleEventBackground',
    'sponsors',
  ],
}

const { errorObject } = useShowApiError('Team Not Found')
const { fetchData } = useLoadTeamBySlug(slug.value, paramsSearch)
const { data, error } = await useAsyncData(`team-${slug.value}`, () => fetchData())

if (error.value) {
  throw errorObject
}
const { seoMetaInput, headInput, team } = useTeam(data)

useSeoMeta(seoMetaInput.value)
useHead(headInput.value)
</script>

<template>
  <div class="team">
    <NuxtLayout
      name="team"
      :team
    >
      <NuxtPage
        v-if="team"
        :team
      />
    </NuxtLayout>
  </div>
</template>
